<div class="tablet-sidebar">
  <!-- Logo -->
  <div class="logo-container">
    <img
      src="/assets/icons/haulverse-icon.svg"
      alt="Haulverse Logo"
      class="logo"
    />
  </div>

  <!-- Main Navigation -->
  <nav class="nav-main">
    @for (item of navService.topNavItems(); track item.label) {
    <a
      [routerLink]="item.route"
      routerLinkActive="active"
      class="nav-item"
      [title]="item.label"
    >
      <lucide-icon [name]="item.icon" class="nav-icon"></lucide-icon>
    </a>
    }
  </nav>
</div>
